document.addEventListener('DOMContentLoaded', () => {
    function attachYandexEvent(selector, eventType, yandexGoal) {
        var elements = document.querySelectorAll(selector)

        elements.forEach(function(element) {
            element.addEventListener(eventType, function() {
                try {
                    // eslint-disable-next-line
                    ym(99773160, 'reachGoal', yandexGoal)
                    // eslint-disable-next-line
                } catch (error) {}
            })
        })
    }

    function attachYandexDynamicEvent(parentSelector, childSelector, eventType, yandexGoal) {
        var parentElements = document.querySelectorAll(parentSelector)

        parentElements.forEach(function(parentElement) {
            var childElements = parentElement.querySelectorAll(childSelector)

            childElements.forEach(function(childElement) {
                // eslint-disable-next-line
                childElement.addEventListener(eventType, function() {
                    try {
                        // eslint-disable-next-line
                        ym(99773160, 'reachGoal', yandexGoal)
                        // eslint-disable-next-line
                    } catch (error) {}
                })
            })
        })
    }

    // eslint-disable-next-line
    function attachFormEvent(parentSelector, formSelector) {
        var parentElements = document.querySelectorAll(parentSelector)

        parentElements.forEach(function(parentElement) {
            var formElements = parentElement.querySelectorAll(formSelector)

            formElements.forEach(function(formElement) {
                // eslint-disable-next-line
                formElement.addEventListener('done', function() {
                    var yandexGoal
                    if (parentElement.classList.contains('modal--dark')) {
                        yandexGoal = 'order_franshiza'
                    } else {
                        yandexGoal = 'order_platform'
                    }

                    try {
                        // eslint-disable-next-line
                        ym(99773160, 'reachGoal', yandexGoal)
                        // eslint-disable-next-line
                    } catch (error) {}
                })
            })
        })
    }

    // eslint-disable-next-line
    attachYandexEvent('.site-header .button', 'click', 'click_participate_header')
    // eslint-disable-next-line
    attachYandexDynamicEvent('.aside-menu', '.button', 'click', 'click_participate_header')
    // eslint-disable-next-line
    attachYandexEvent('.hero .hero__button', 'click', 'click_participate_block_1')
    // eslint-disable-next-line
    attachYandexEvent('.logo-slider-section .button', 'click', 'click_participate_block_4')
    // eslint-disable-next-line
    attachYandexEvent('.site-footer .button.site-footer__btn', 'click', 'click_register_footer')
    // eslint-disable-next-line
    attachYandexEvent('.site-footer__contacts--tel', 'click', 'click_phone_footer')
    // eslint-disable-next-line
    attachYandexEvent('.site-footer__contacts--mail', 'click', 'click_email_footer')
    // eslint-disable-next-line
    attachYandexDynamicEvent('.modal-block', '.modal-form__submit', 'click', 'click_lead')

    setTimeout(function () {
        try {
            // eslint-disable-next-line
            ym(99773160, 'reachGoal', 'time_on_site_3_min')
            // eslint-disable-next-line
        } catch (error) {}
    }, 180000)
})
